import { render, staticRenderFns } from "./TripDeviceAssignmentModal.vue?vue&type=template&id=64007034"
import script from "./TripDeviceAssignmentModal.vue?vue&type=script&lang=js"
export * from "./TripDeviceAssignmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports